class NodeBackend {
  
    getPath() {
      const PROD_MODE = true;
      if(PROD_MODE){
        // PRODUCTION
        return("https://next-stock-c6beaf5af154.herokuapp.com/v1/next-stock/"); 
      } else{
        // TESTING ENV.
        return("http://localhost:5001/v1/next-stock/"); 
      }
    }
  }
  
  // Export the class
  export default NodeBackend;